// extracted by mini-css-extract-plugin
export default {"item":"index-module__item--46xEP","item--selected":"index-module__item--selected--UofsB"};